<template>
  <common-report-card
    :configs="configs"
    :cardTitle="'Báo cáo văn bản theo trạng thái'"
    @viewReportDetail="viewReportDetail"
  ></common-report-card>
</template>

<script>
import constants from "../../constants";
import utils from "../../services/utils";
import CommonReportCard from "./common-report-card";
import h from "../../services/h";

export default {
  name: "vb-doc-report-card",
  props: ["menuConfigs"],
  components: {
    CommonReportCard,
  },

  data() {
    return {
      configs: []
    };
  },

  created() {
    this.initConfigs();
  },

  methods: {

    isEnableMenu(menuCode) {
      return h.exists(this.menuConfigs, item => item.menuCode === menuCode);
    },

    initConfigs() {
      this.configs = [];

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_VBTHEOTRANGTHAI)) && (
        this.configs.push({
          title: "Báo cáo văn bản đến theo đơn vị",
          reportType: constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_DONVI
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_TINHHINHXLVB)) && (
        this.configs.push({
          title: "Báo cáo tình hình xử lý văn bản theo đơn vị",
          reportType: constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_TINHHINHXLVB
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_TINHHINHXLVB)) && (
        this.configs.push({
          title: "Báo cáo thống kê số lượng văn bản đã phát hành theo cá nhân,đơn vị",
          reportType: constants.REPORT.VB_DOC.TYPE.OUTGOING_DOC_VBDIDAPHATHANH
        })
      );

      (this.isEnableMenu(constants.MENU_LIST.BAOCAO_TINHHINHXLVB)) && (
        this.configs.push({
          title: "Báo cáo tình hình xử lý văn bản đến của các đơn vị trong TCT",
          reportType: constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_TINHHINHXLVBTHEODONVI
        })
      );
    },

    viewReportDetail(event) {

      let config = event.config;
      let routerName;
      let query;

      switch (config.reportType) {
        case constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_DONVI:
          this.viewReportDetail_(config);
          return;
        case constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_TINHHINHXLVB:
          routerName = "tinhHinhXuLyVb";
          break;
        case constants.REPORT.VB_DOC.TYPE.OUTGOING_DOC_VBDIDAPHATHANH:
          routerName = "baoCaoVbDiDaPhatHanh";
          break;
        case constants.REPORT.VB_DOC.TYPE.INCOMING_DOC_TINHHINHXLVBTHEODONVI:
          routerName = "tinhHinhXuLyVanBanDenTheoDonVi";
          break;
      }

      this.$router.push({
        name: routerName,
        params: this.$route.params,
        query: utils.merge(this.$route.query, query)
      });
    },

    viewReportDetail_(config) {
      let query = utils.merge(this.$route.query, {reportType: config.reportType});
      this.$router.push({
        name: "vbDocReport",
        params: this.$route.params,
        query: query
      });
    }
  }
};
</script>

<style lang="css">
.pCardReport {
  height: 300px;
  margin-bottom: 24px;
  padding: 0 10px;
}

.pCardReport .body {
  height: calc(100% - 105px);
}

.pCardReport .title {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 12px;
}

.pCardReport .scroll-body {
  height: 100%;
}

.pCardReport .file-name {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/views/report/vbDocReportCard.vue